import { useEffect, useState } from 'react';
import { setSharedCookie, getSharedCookie } from '../../Utils/CookieUtils';
import { useSearchParams } from 'react-router-dom';

/**
 * 
 * @returns 
 */
export function ManageDonneesPersonnelles
    (
        interaction,
        participation,
        changerPage,
    ) {

    const [userInformation, setUserInformation] = useState({
        'first_name': '',
        'name': '',
        'city': '',
        'phone': '',
        'email': '',
        'age': '',
    });

    const [donneesPersonnelleValid, setDonneesPersonnelleValid] = useState({
        'first_name': true,
        'name': true,
        'city': true,
        'phone': true,
        'email': true,
        'age': true,
    });

    const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegexp = /^(0\d{9}|\+?[1-9]\d{1,14})$/;

    const [canDonneesPersonnelleContinue, setCanDonneesPersonnelleContinue] = useState(false);

    let refPeutContinuer = { ...canDonneesPersonnelleContinue };

    const [rememberMe, setRememberMe] = useState(false);

    let [searchParams,] = useSearchParams();
    const handleRememberMeChange = (event) => {
        // Fonctionnement avec LocalStorage
        if (searchParams.get('sameDomain') !== "true" && window.location.protocol !== 'http:') {
            console.log('Use localStorage')
            try {
                document.requestStorageAccess();
                setNeedsPermission(false);
            } catch (err) {
                console.error("Accès refusé ou erreur :", err);
            }
        }
        else {
            console.log('Use cookieStorage')
        }
        setRememberMe(event.target.checked);
        // Purge directement ici si on ne souhaite plus sauvegarder les données
        if(!event.target.checked) {
            localStorage.removeItem('userInformation');
            setSharedCookie('userInformation', '', -1);
        }
    };

    const setField = (event) => {
        event.preventDefault();
        userInformation[event.target.name] = event.target.value.trim();
        setUserInformation(userInformation);
        //validateUserInformationsValid();
    };

    let isInitialise = false;

    const intialisationDonneesPersonnelles = () => {
        if (!isInitialise && interaction.information_to_gather) {
            setUserInformation({
                'first_name': '',
                'name': '',
                'city': '',
                'phone': '',
                'email': '',
                'age': '',
            });
            let previousSavedUserInformation = JSON.parse(localStorage.getItem('userInformation'));
            // Fonctionnement avec Cookie si le domaine est identique
            if (searchParams.get('sameDomain') === "true") {
                previousSavedUserInformation = JSON.parse(getSharedCookie("userInformation"));
            }

            if (previousSavedUserInformation) {
                setRememberMe(true);
                Object.keys(previousSavedUserInformation).forEach((key) => {
                    if (interaction.information_to_gather.hasOwnProperty(key) && interaction.information_to_gather[key].hasOwnProperty('active') && interaction.information_to_gather[key].active) {
                        setUserInformation((prev) => ({ ...prev, [key]: previousSavedUserInformation[key] }))
                    }
                });

            }

            isInitialise = true;
        }
    }
    const [needsPermission, setNeedsPermission] = useState(false);

    useEffect(() => {
        if (interaction.information_to_gather) {
            // Vérifier si l'API existe et si nous avons déjà l'accès
            const checkAccess = async () => {
                if (document.hasStorageAccess) {
                    const hasAccess = await document.hasStorageAccess();
                    if (!hasAccess) {
                        setNeedsPermission(true);
                    }
                }
            };
            checkAccess();

            intialisationDonneesPersonnelles();
        }
    }, [interaction.information_to_gather]);

    const validateUserInformationsValid = async () => {
        Object.keys(interaction.information_to_gather).forEach((key) => {

            if (!interaction.information_to_gather[key].active) {
                return;
            }

            if (interaction.information_to_gather[key].mandatory && userInformation[key].length === 0) {
                donneesPersonnelleValid[key] = false;
                setDonneesPersonnelleValid(donneesPersonnelleValid);
                return;
            }

            if (key === 'email' && userInformation[key] !== '') {

                if (!emailRegexp.test(userInformation[key])) {
                    donneesPersonnelleValid[key] = false;
                    return;
                }
                donneesPersonnelleValid[key] = true;
                setDonneesPersonnelleValid(donneesPersonnelleValid);
                return;
            }

            if (key === 'phone' && userInformation[key] !== '') {
                if (!phoneRegexp.test(userInformation[key])) {
                    donneesPersonnelleValid[key] = false;
                    return;
                }
                donneesPersonnelleValid[key] = true;
                setDonneesPersonnelleValid(donneesPersonnelleValid);
                return;
            }

            donneesPersonnelleValid[key] = true;
            setDonneesPersonnelleValid(donneesPersonnelleValid);
        });

        refPeutContinuer = !Object.values(donneesPersonnelleValid).includes(false);
        setCanDonneesPersonnelleContinue(refPeutContinuer);
        return refPeutContinuer;
    }

    const saveDonneePersonnelle = async () => {
        const peutContinuer = await validateUserInformationsValid();
        if (rememberMe) {
            sauvegardeUserInfoRememberMe();
        }
        if(peutContinuer) {
            participation.extra_user_information = userInformation;
            changerPage();
        }
    };

    //La sauvegarde dans le localstorage prend en compte les éléments saisie lors d'autres formulaires, avec plus de champs, afin de ne pas écraser les champs de ces formulaires par ceux non démandé dans le formulaire en cours. -> Il n'écrase que par des données non vide ''.
    const sauvegardeUserInfoRememberMe = () => {
        if (rememberMe) {

            let previousSavedUserInformation = localStorage.getItem('userInformation');
            // Fonctionnement avec Cookie si le domaine est identique
            if (searchParams.get('sameDomain') === "true") {
                previousSavedUserInformation = getSharedCookie('userInformation') || localStorage.getItem("userInformation");
            }
            let updatedUserInformation = {};

            if (previousSavedUserInformation) {
                try {
                    previousSavedUserInformation = JSON.parse(previousSavedUserInformation);
                    if (typeof previousSavedUserInformation === 'object' && previousSavedUserInformation !== null) {
                        // Filtrer les champs non vides de userInformation avant la fusion afin de le pas 
                        const filteredUserInformation = {};
                        for (let key in userInformation) {
                            if (userInformation[key] !== '') {
                                filteredUserInformation[key] = userInformation[key];
                            }
                        }
                        updatedUserInformation = { ...previousSavedUserInformation, ...filteredUserInformation };
                    } else {
                        updatedUserInformation = { ...userInformation };
                    }
                } catch (error) {
                    console.error('Erreur lors de la récuperation des données local', error);
                    updatedUserInformation = { ...userInformation };
                }
            } else {
                updatedUserInformation = { ...userInformation };
            }

            // Fonctionnement avec Cookie si le domaine est identique
            if (searchParams.get('sameDomain') === "true") {
                setSharedCookie('userInformation', JSON.stringify(updatedUserInformation), 365)
            }
            else {
                localStorage.setItem('userInformation', JSON.stringify(updatedUserInformation));
            }
        } else {
            localStorage.removeItem('userInformation');
            setSharedCookie('userInformation', '', -1);
        }
    };

    useEffect(() => {
        setCanDonneesPersonnelleContinue(!Object.values(donneesPersonnelleValid).includes(false));
    }, [donneesPersonnelleValid, userInformation]);

    return {
        setField,
        saveDonneePersonnelle,
        intialisationDonneesPersonnelles,
        userInformation,
        donneesPersonnelleValid,
        handleRememberMeChange,
        rememberMe,
        canDonneesPersonnelleContinue,
        validateUserInformationsValid
    }

}

